<template lang="pug">
    .about-banner(:style="{ 'background-image': 'url(' + image + ')' }")
        .container
            .row
                .col-md-12
                    | {{ name }}
</template>


<script>
export default {
    props: ["name", "image"]
}
</script>


// WEBPACK FOOTER //
// src/components/atoms/PmBanner.vue